<template>
  <Control :title="title" :isEdit="true"  :tooltip="tooltip"  :key="title" :hasValue="value != nullValue && value != ''">
    <template slot="edit">
      <div class="cx_filterbox">
        <b-form-input ref="target" v-model="internalValue" type="text" :placeholder="placeholder" autocomplete="off" size="sm"></b-form-input>
        <div v-if="value != nullValue && value != ''" class="inline_button delete" @mousedown="onDelete">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
        <b-button @click="OnClick">
          <i class="material-symbols-outlined small valign">search</i>
        </b-button>
      </div>
    </template>
  </Control>
</template>
<script lang="ts">
import { Component, Vue, Prop,Emit } from 'vue-property-decorator';
import * as Components from '@/agiles/components';

@Component
export default class FilterBox extends Vue {

  @Prop({default:''}) public title?: string;
  @Prop({default:null}) public value?: string;
  @Prop({default:''}) public placeholder?: string;
  @Prop({ default: null }) public nullValue: any;
  @Prop({ default: false }) public isNumber: boolean;
  @Prop() public tooltip: string;

  public get internalValue(): string {
    return this.value;
  }
  
  @Emit('click')
  public OnClick() {}

  public onDelete(event: MouseEvent) {
    this.internalValue = this.nullValue;
    ((this.$refs.target as Vue).$el as HTMLElement).focus();
    event.preventDefault();
    this.OnClick();
  }

  public set internalValue(value: string) {
    //数値フラグONで数値に変換できない場合にnullValueをセット
    if (this.isNumber && isNaN(Number.parseFloat(value))){
      this.$emit('update:value', this.nullValue);
    } else {
      // 親コンポーネント側で更新
      this.$emit('update:value', value);
    }

  }
}

</script>
<style lang="scss">
.cx_filterbox{
    display: flex;
    position: relative;
    input.form-control-sm {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        border-right:none;
    }
    button{
           padding: 1px 2px;
            font-size: 14px;
            line-height: 16px;
                    border-top-left-radius: 0rem;
        border-bottom-left-radius: 0rem;
    }
      .inline_button {
        cursor: pointer;
        height: 20px;
        margin-top: 0px;
        right: 25px;
        position: absolute;
        padding: 0 2px;
        svg {
          height: 14px;
          width: 14px;
          fill: #444;
        }
        &.delete svg {
          fill: lightgray;
          &:hover {
            fill: rgb(238, 83, 83);
          }
        }
      }
}
</style>